<form [formGroup]="form">
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0">Summary</p-tab>
      <p-tab value="1">Process Details</p-tab>
      <p-tab value="2">Audit</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-section-card name="Summary" [contentPadding]="[14, 14]">
          <div class="summary">
            {{ data.instructions || "No Summary for " + data.processModule }}
          </div>
        </app-section-card>
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-section-card name="Process Details" [contentPadding]="[14, 14]">
          <ng-template #actions *ngIf="canEdit">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="onCancel()" severity="secondary"></p-button>
            <p-button label="Save" icon="pi pi-save" (onClick)="onSubmit()"></p-button>
          </ng-template>
          <div class="grid">
            <div class="col-6">
              <div class="field">
                <label for="PERMRole">PERM Role</label>
                <p-select
                  id="PERMRole"
                  [options]="permRoleList"
                  formControlName="PERMRole"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select PERM Role"
                  class="w-full"
                ></p-select>
              </div>
            </div>
            <div class="col-6">
              <div class="field">
                <label for="AnticipatedFiling">Anticipated Filing</label>
                <app-date-picker id="AnticipatedFiling" formControlName="AnticipatedFiling" class="w-full"></app-date-picker>
              </div>
            </div>
            <div class="col-6">
              <div class="field">
                <label for="EVLStatus">EVL Status</label>
                <p-select
                  id="EVLStatus"
                  [options]="matterEVLStatusList"
                  formControlName="EVLStatus"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Select EVL Status"
                  class="w-full"
                ></p-select>
              </div>
            </div>
            <div class="col-6">
              <div class="field">
                <label for="EmployerHadLayoffYes">Has the employer had layoffs</label>
                <div class="flex flex-wrap gap-4 mt-2">
                  <div class="flex items-center">
                    <p-radiobutton name="EmployerHadLayoff" [value]="true" formControlName="EmployerHadLayoff" inputId="EmployerHadLayoffYes" />
                    <label for="EmployerHadLayoffYes" class="ml-2">Yes</label>
                  </div>
                  <div class="flex items-center">
                    <p-radiobutton name="EmployerHadLayoff" [value]="false" formControlName="EmployerHadLayoff" inputId="EmployerHadLayoffNo" />
                    <label for="EmployerHadLayoffNo" class="ml-2">No</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </app-section-card>
      </p-tabpanel>
      <p-tabpanel value="2">
        <app-section-card name="Audit" [contentPadding]="[14, 14]">
          <ng-template #actions *ngIf="canEdit">
            <p-button label="Cancel" icon="pi pi-times" (onClick)="onCancel()" severity="secondary"></p-button>
            <p-button label="Save" icon="pi pi-save" (onClick)="onSubmit()"></p-button>
          </ng-template>
          <div class="grid">
            <div class="col-12">
              <div class="field">
                <label for="Audited">Was PERM Audited</label>
                <div class="flex flex-wrap gap-4">
                  <div class="flex items-center">
                    <p-radiobutton name="Audited" [value]="true" formControlName="Audited" inputId="AuditedfYes" />
                    <label for="AuditedfYes" class="ml-2">Yes</label>
                  </div>
                  <div class="flex items-center">
                    <p-radiobutton name="Audited" [value]="false" formControlName="Audited" inputId="AuditedNo" />
                    <label for="AuditedNo" class="ml-2">No</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="field">
                <label for="AuditReceived">PERM audit Received</label>
                <app-date-picker id="AuditReceived" formControlName="AuditReceived" class="w-full"></app-date-picker>
              </div>
            </div>
            <div class="col-6">
              <div class="field">
                <label for="AuditResponseDue">PERM Response Due</label>
                <app-date-picker id="AuditResponseDue" formControlName="AuditResponseDue" class="w-full"></app-date-picker>
              </div>
            </div>
            <div class="col-6">
              <div class="field">
                <label for="AuditResponseSubmitted">PERM Response Submitted</label>
                <app-date-picker id="AuditResponseSubmitted" formControlName="AuditResponseSubmitted" class="w-full"></app-date-picker>
              </div>
            </div>
          </div>
        </app-section-card>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</form>
